<template>
  <div class="form p-2">
    <!-- Many Power Type Modal -->
    <b-modal centered id="addManPowerTypeModal1" :static="true" class="" title="Add Manpower Type" hide-footer>
      <manpower-type-form
          :onSave="handleManPowerTypeSave"
      />
      
  </b-modal>
    <div class="row">
      <div class="col">
        <label class="dob-input">Manpower Type</label>
        <b-input-group class="custom-input-group">
            <multiselect v-model="selected_mt" @input="handleManPowerTypeChange" :options="manPowerTypes"  track-by="id" label="name" class="is-invalid" :disabled="manpowerTypeDisabled"></multiselect>
            <b-input-group-append>
            <b-button variant="primary" v-b-modal.addManPowerTypeModal1 :disabled="manpowerTypeDisabled">+</b-button>
            </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback 
          :class="{ 'd-block mb-2': isSubmit && errorMsg.manpowerTypeId }">
          {{ isSubmit && errorMsg.manpowerTypeId ? errorMsg.manpowerTypeId : '' }}
        </b-form-invalid-feedback>
      </div>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <label for="fullName">Interval</label>
                <multiselect v-model="rate_card.durationType" @input="handleDurationTypeChange" :options="intervals" :searchable="true"  ></multiselect>
                <b-form-invalid-feedback 
                  :class="{ 'd-block mb-2': isSubmit && errorMsg.durationType }">
                  {{ isSubmit && errorMsg.durationType ? errorMsg.durationType : '' }}
                </b-form-invalid-feedback>
            </div>
        </div>
        <div class="col-sm-6">
            <div id="username-field" class="field-wrapper input" v-if="contractDetail && contractDetail.manpowerTypeId">
                <label for="email">Amount</label>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <b-input type="number" :placeholder="contractDetail.amount.toString() || ''" v-model="rate_card.rate" @blur="validateAmount" :state="isValidAmount">
                </b-input>
                <b-form-invalid-feedback v-if="!isValidAmount">
                    Salary should be Less {{ Number(contractDetail.amount) }}
                </b-form-invalid-feedback>
            </div>
            <div id="username-field" class="field-wrapper input" v-else>
                <label for="email">Amount</label>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <b-input placeholder="e.g 12000" v-model="rate_card.rate" :class="[isSubmit ? (errorMsg.rate ? 'is-invalid' : 'is-valid') : '']"></b-input>
                <b-form-invalid-feedback 
                  :class="{ 'd-block mb-2': isSubmit && errorMsg.rate }">
                  {{ isSubmit && errorMsg.rate ? errorMsg.rate : '' }}
                </b-form-invalid-feedback>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <label for="fullName">Effective Date</label>
                <flat-pickr v-model="rate_card.effective_date" class="form-control flatpickr active"></flat-pickr>
                <b-form-invalid-feedback 
                  :class="{ 'd-block mb-2': isSubmit && errorMsg.effective_date }">
                  {{ isSubmit && errorMsg.effective_date ? errorMsg.effective_date : '' }}
                </b-form-invalid-feedback>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="form-group">
                <label for="fullName">End Date</label>
                <flat-pickr v-model="rate_card.end_date" class="form-control flatpickr active"></flat-pickr>
            </div>
        </div>
    </div>
    <div class="row" v-if="rate_card.id">
      <div class="col text-center">
        <b-button variant="primary" @click="updateRateCard">Update</b-button>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col text-center">
        <b-button variant="primary" @click="saveRateCard">Save</b-button>
      </div>
    </div>
  </div>
</template>
  <style scoped>
  .custom-input-group {
    display: flex;
}

.custom-input-group .multiselect {
    flex: 1; /* Allows the multiselect to grow and fill the available space */
}

.custom-input-group .input-group-append {
    flex-shrink: 0; /* Prevents the button from shrinking */
}

  </style>
  <script>
  //flatpickr
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import '@/assets/sass/forms/custom-flatpickr.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import ManpowerTypeForm from '@/components/module/ManpowerTypeForm.vue';

export default {
  props: {
    initialRateCard: {
      type: Object,
      required: false,
    },
    contractDetail: {
      type: Object,
      required: false,
    },
    onSave: {
      type: Function,
      required: true,
    },
  },
  components: {
   Multiselect,
   ManpowerTypeForm,
   flatPickr
  },
  data() {
    return {
      rate_card: this.initialRateCard ? { ...this.initialRateCard } : {
        id:null,
        manpowerTypeId:null,
        durationType:'monthly',
        rate:null,
        effective_date:new Date().toISOString().substr(0, 10),
        end_date:null,
      },
      intervals: ['monthly', 'hourly', 'daily', 'weekly','yearly'],
      selected_mt:null,
      errorMsg:{},
      isSubmit: false,
      sa:null,
      manpowerTypeDisabled: false,
    };
  },
  computed: {
    manPowerTypes() {
      const manPowerTypes = this.$store.state.business.manpower_types;
      if (this.contractDetail && this.contractDetail.manpowerTypeId) {
        const selectedManPowerTypes = manPowerTypes.filter(mt => mt.id === this.contractDetail.manpowerTypeId);
        return selectedManPowerTypes;
      } else {
        return manPowerTypes;
      }
    },
    isValidAmount() {
            const amount = Number(this.rate_card.rate);
            const maxAmount = Number(this.contractDetail.amount);
            return amount <= maxAmount
        },
  },
  async mounted(){
    this.sa = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
      });
    await this.$store.dispatch('business/getManPowerTypes');
    if(this.contractDetail && this.contractDetail.manpowerTypeId){
      this.manpowerTypeDisabled = true;
      this.selected_mt = this.manPowerTypes.find(mt => mt.id === this.contractDetail.manpowerTypeId);
      this.rate_card.manpowerTypeId = this.contractDetail.manpowerTypeId;
    }
  },
  watch: {
    initialRateCard(newVal) {
      this.rate_card = { ...newVal };
      if(newVal.id){
        this.selected_mt = this.manPowerTypes.find(mt => mt.id === newVal.manpowerTypeId);
      }
    }
  },
  methods: {
    
    validateAmount() {
            if (!this.isValidAmount) {
                this.rate_card.rate = null // Reset the amount if it's not valid
                // Optionally, you can show an error message or handle the invalid input as needed
            }
        },
    handleManPowerTypeSave(manpower_type){
        this.selected_mt = manpower_type;
        this.handleManPowerTypeChange(manpower_type);
        this.$bvModal.hide('addManPowerTypeModal1');
    },
    handleDurationTypeChange(selectedOption) {
        this.rate_card.durationType = selectedOption ? selectedOption : null;
    },
    handleManPowerTypeChange(selectedOption) {
        this.rate_card.manpowerTypeId = selectedOption ? selectedOption.id : null;
    },
    validateFields(){
      let flag = false;

      if(!this.rate_card.manpowerTypeId){
        flag = true;
        this.$set(this.errorMsg, 'manpowerTypeId', 'Manpower Type is Required!');
      }
      if(!this.rate_card.rate || (this.rate_card && this.rate_card < 0)){
         flag = true;
         this.$set(this.errorMsg, 'rate', 'Rate Cannot be less than 0 or empty!');
      }
      if(!this.rate_card.durationType){
         flag = true;
         this.$set(this.errorMsg, 'durationType', 'Select One Of the Option');
      }
      if(!this.rate_card.effective_date){
         flag = true;
         this.$set(this.errorMsg, 'effective_date', 'Select Date');
      }
      if(!flag){
        return true
      }else{
        return false
      }
    },
    resetFields(){
      this.rate_card={
          id:null,
          manpowerTypeId:null,
          durationType:null,
          rate:null,
          effective_date:new Date().toISOString().substr(0, 10),
          end_date:null,
      };
      
      this.selected_mt=null
      this.errorMsg={}
      this.isSubmit= false;
    },
    async saveRateCard() {
      this.errorMsg = {};
      this.isSubmit = true;
      if(this.validateFields()){
        await this.$store.dispatch('business/addRateCard', this.rate_card)
        const newRateCard = await this.$store.state.business.addedRateCard
        this.sa.fire({
              icon: 'success',
              title: `Rate Card Successfully Added!`
        });
        this.onSave(newRateCard); // Use the provided onSave handler
        this.resetFields();
      }else{
        this.sa.fire({
              icon: 'error',
              title: `Check For Errors!`
        });
      }
    },
    async updateRateCard() {
      this.errorMsg = {};
      this.isSubmit = true;
      if(this.validateFields()){
        await this.$store.dispatch('business/updateRateCard', this.rate_card)
        const newRateCard = await this.$store.state.business.addedRateCard
        this.sa.fire({
              icon: 'success',
              title: `Rate Card Successfully Updated!`
        });
        this.onSave(newRateCard); // Use the provided onSave handler
        this.resetFields();
      }else{
        this.sa.fire({
              icon: 'error',
              title: `Check For Errors!`
        });
      }
    },
    handleSave(){

    }
  },
};
</script>